<template>
    <div class="modal-proguard-setting">
        <img src="/../img/ic-m-close.svg" @click="onClick" />
        <div class="slot1">
            <span class="title">{{ proguardTitle }}</span>
        </div>
        <div class="slot2">
            <proguard-table
                :init_items="fileList"
                :init_fields="fileFields"
                :init_height="'480px'"
                @reloadFileList="getFileList"
            ></proguard-table>
        </div>
        <div class="slot3">
            <div class="file-input">
                <div class="file-upload">
                    <div class="row">
                        <div class="vertical-text-frame mapping-text-wrap">
                            <span
                                class="mapping-text"
                                v-html="$t('proguard.file')"
                            ></span>
                        </div>
                        <div class="file-upload-wrap">
                            <div class="file-upload-inner-wrap">
                                <input
                                    id="mapping-file-input"
                                    type="file"
                                    @change="onSelectFile"
                                    :accept="platformAccept"
                                />
                                <button class="btn-upload" @click="uploadFile">
                                    {{ $t("proguard.select_file") }}
                                </button>
                                <div class="vertical-text-frame-inner ml10">
                                    <span>
                                        <div
                                            class="label-upload"
                                            @click="uploadFile"
                                        >
                                            {{ selectedFileName }}
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="app-version">
                    <div class="row">
                        <div class="vertical-text-frame mla">
                            <span class="version-text">{{
                                $t("proguard.appversion")
                            }}</span>
                        </div>
                        <input
                            class="version-input"
                            type="text"
                            v-model="appVersion"
                            maxlength="50"
                        />
                    </div>
                </div>
            </div>
            <div class="file-guide-text">
                <div class="row" v-html="guideText"></div>
            </div>
            <span class="seperate-line"></span>
            <div class="upload-action">
                <button
                    class="submit"
                    v-if="mappingFile && appVersion"
                    @click="onSubmit"
                >
                    {{ $t("common.submit") }}
                </button>
                <button class="disable-submit" v-else>
                    {{ $t("common.submit") }}
                </button>
                <button class="cancel" @click="onClick">
                    {{ $t("common.cancel") }}
                </button>
            </div>
            <cprogress
                :init_loading="loading"
                :init_message="$t('project.loading')"
                :init_abs="true"
                init_transition="all 30s"
            ></cprogress>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ProguardTable from "./proguard-table.vue";
import Ctooltip from "../../components/ctooltip.vue";
import Cprogress from "../../components/cprogress-bar.vue";

export default {
    name: "modal-proguard-setting",
    components: {
        ProguardTable,
        Ctooltip,
        Cprogress,
    },
    data: function () {
        return {
            mappingFile: null,
            fileList: [],
            appVersion: "",
            fileFields: [
                { key: "filename", label: this.$t("proguard.file") },
                { key: "appversion", label: this.$t("proguard.appversion") },
                { key: "uploadtime", label: this.$t("proguard.time") },
            ],
            loading: false,
        };
    },
    computed: {
        selectedFileName: function () {
            if (this.mappingFile && this.mappingFile.name.length) {
                return this.mappingFile.name;
            } else {
                return this.$t("proguard.nofile");
            }
        },
        proguardTitle() {
            return this.$store.state.modalProps.platform === "android"
                ? this.$t("project.menu.proguard")
                : this.$t("project.menu.dsym");
        },
        guideText() {
            return this.$store.state.modalProps.platform === "android"
                ? this.$t("proguard.fail_upload_guide_aos")
                : this.$t("proguard.fail_upload_guide_ios");
        },
        platformAccept() {
            //AOS는 확장자 .txt 파일만, IOS는 .dSYM 파일만(브라우저에서는 .zip으로 자동 인식)

            // 23-02-13 dSYM unix 실행 파일 자체를 업로드 할 수 있도록 수정
            const result =
                this.$store.state.modalProps.platform === "android"
                    ? "text/plain"
                    : "";
            return result;
        },
    },
    created: function () {
        this.setData();
    },
    methods: {
        setData: function () {
            this.getFileList();
        },
        getFileList: function () {
            setTimeout(() => {
                this.loading = true;
                axios
                    .get(
                        `/api/upload/${this.$store.state.modalProps.pId}/${this.$store.state.modalProps.ftype}?timezone=${this.$store.state.timezone}`
                    )
                    .then((result) => {
                        this.fileList = result.data;
                        this.loading = false;
                    });
            }, 0);
        },
        onClick: function () {
            this.$emit("closeEvent", true);
        },
        onSelectFile: function (event) {
            const { files } = event.target;

            if (!files[0]) {
                this.mappingFile = null;
                return;
            }
            const validateFile = this.isValidateFile(
                files[0],
                this.$store.state.modalProps.platform
            );
            if (!validateFile) {
                this.mappingFile = null;
                alert(this.$t("proguard.invalid_file"));
                return;
            }
            this.mappingFile = files[0];
        },
        uploadFile: function () {
            document.getElementById("mapping-file-input").click();
        },
        onSubmit: function () {
            const validateFile = this.isValidateFile(
                this.mappingFile,
                this.$store.state.modalProps.platform
            );

            if (!validateFile) {
                alert(this.$t("proguard.invalid_file"));
                return;
            }
            const formData = new FormData();
            formData.append("appversion", this.appVersion);
            formData.append("timezone", this.$store.state.timezone);
            formData.append("file_dir", this.mappingFile);

            axios
                .post(
                    `/api/upload/${this.$store.state.modalProps.pId}/${this.$store.state.modalProps.ftype}`,
                    formData
                )
                .then(() => {
                    alert(this.$t("proguard.finish"));
                })
                .then(() => {
                    this.getFileList();
                    this.mappingFile = null;
                    this.appVersion = null;
                    document.getElementById("mapping-file-input").value = null;
                })
                .catch((error) => {
                    if (error.response.status === 413) {
                        // 용량 초과
                        alert(this.$t("proguard.fail_upload_size"));
                    } else {
                        alert(this.$t("proguard.fail_upload"));
                    }
                });
        },
        // 23-02-13 dSYM unix 실행 파일 자체를 업로드 할 수 있도록 수정
        isValidateFile(mappingFile, platform) {
            const mappingFileNameSplit = mappingFile.name.split(".");
            const mappingExtension =
                mappingFileNameSplit[mappingFileNameSplit.length - 1];
            if (platform === "android") {
                // 확장자가 txt인지 확인
                return mappingFile.type && mappingExtension.includes("txt");
            } else {
                // 확장자가 없는지 확인
                return !mappingFile.type && mappingFileNameSplit.length < 2;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-proguard-setting {
    margin: auto;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.54);
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    z-index: 4;
    box-sizing: border-box;
    width: 711px;
    height: 711px;
    & > img {
        position: absolute;
        top: 0px;
        cursor: pointer;
        left: 721px;
    }
}
.row {
    width: 100%;
    display: flex;
    flex-direction: row;
}
.slot1 {
    width: 100%;
    padding: 14px 30px 23px 30px;
    box-sizing: border-box;
}
.title {
    font-size: 24px;
    color: #000000;
}
.slot2 {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    max-height: 480px;
    overflow: hidden;
}
.slot3 {
    margin-top: auto;
    height: 200px;
    width: 100%;
    background-color: #f6f6f6;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.file-input {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 45px;
    margin-top: 16px;
    padding: 0 20px;
    box-sizing: border-box;
}
.file-upload {
    width: 55%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .row {
        align-items: flex-start;
    }
}

.mapping-text-wrap {
    height: 37px;
}

.vertical-text-frame {
    // width: 77px;
    display: flex;
    align-items: center;
    span {
        vertical-align: middle;
    }
}
.vertical-text-frame-inner {
    display: flex;
    align-items: center;
    width: 50%;
    span {
        vertical-align: middle;
    }
}
.ml10 {
    margin-left: 10px;
}
.tooltip {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: normal;
    margin-left: 6px;
    line-height: 21px;
    box-sizing: border-box;
}
#mapping-file-input {
    width: 0;
    height: 0;
}

.file-upload-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.file-upload-inner-wrap {
    height: 37px;
    align-items: center;
    display: flex;
}
.file-guide-text {
    margin-left: 25px;
    font-size: 13px;
    color: #242424;
    margin-top: 5px;
    position: relative;
}

.btn-upload {
    min-width: 74px;
    max-width: 91px;
    // width: auto;
    height: 31px;
    border-radius: 8px;
    background-color: #717171;
    color: #ffffff;
    outline: none;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    border: none;
}
.label-upload {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    color: #000000;
    cursor: pointer;
}
.app-version {
    width: 45%;
    display: flex;
    flex-direction: column;
}
.seperate-line {
    width: 90%;
    display: flex;
    flex-direction: row;
    border: solid 0.5px #ffffff;
    margin: auto;
    margin-top: 16px;
    margin-bottom: 17px;
}
.upload-action {
    width: 100%;
    flex-direction: row;
    display: flex;
    margin-top: auto;
}
.submit,
.disable-submit {
    width: 120px;
    height: 43px;
    border-radius: 20px;
    box-shadow: 0 2px 4px 0 #c6d5e9;
    color: #ffffff;
    margin-left: auto;
    font-size: 14px;
    font-weight: bold;
    outline: none;
    border: none;
}
.submit {
    background-color: #4639de;
}
.disable-submit {
    pointer-events: none;
    background-color: #cbcbcb;
}
.cancel {
    width: 120px;
    height: 43px;
    border-radius: 20px;
    box-shadow: 0 2px 4px 0 #c6d5e9;
    background-color: #1c1f28;
    margin-left: 11px;
    color: #ffffff;
    margin-right: auto;
    font-size: 14px;
    font-weight: bold;
    outline: none;
    border: none;
}
.mapping-text {
    width: 72px;
    font-size: 13px;
    font-weight: 700;
}
.version-text {
    font-size: 13px;
    font-weight: 700;
}
.version-input {
    outline: none;
    width: 180px;
    height: 33px;
    border-radius: 7px;
    background-color: #ffffff;
    border: solid 1px #979797;
    color: #000000;
    display: inline-block;
    margin-left: 10px;
    font-size: 16px;
    text-indent: 5px;
}
.mla {
    margin-left: auto;
}
</style>
